import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import { withTranslation } from "react-i18next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Table,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { useState } from "react";
import moment from "moment";
import { getOrganizatioanApi, updateLedgers } from "api";

class ExternalPrintLedgerReport extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      validation: "",
      totalPcs: 0,
      totalWeight: 0,
      totalPieces: 0,
      totalAmount: 0,
      organizations: {},
      editRowIndex: -1,
      props: props?.location?.query
        ? props.location.query
        : {
            isEdit: 1,
            data: null,
          },
      ledgerDetailStock:
        props?.location?.query?.isEdit != 1
          ? props?.location?.query?.data?.ledgerDetails
          : [],
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);

    this.products1 = [
      {
        id: "01",
        categories: "HPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "02",
        categories: "LPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "03",
        categories: "REAL",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "04",
        categories: "JIRAM",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
    ];

    this.products2 = [
      {
        id: "01",
        categories: "HPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "02",
        categories: "HPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "03",
        categories: "LPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "04",
        categories: "REAL",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
    ];
  }

  async componentDidMount() {
    const data = await getOrganizatioanApi();
    if (data && data.data) {
      this.setState({
        organizations: data.data.organizations[0],
      });
    }

    let totalSubWeight = 0;

    this.state.ledgerDetailStock.map(x => {
      if (
        x.mainJangad.jangads.reduce((prev, current) => {
          return prev.cycle < current.cycle ? prev : current;
        }).factory.isInternal != true
      ) {
        totalSubWeight += parseFloat(
          x.mainJangad.jangads
            .filter(x => x.factoryId == this.state.props.data.factoryId)
            .reduce((prev, current) => {
              return prev.cycle < current.cycle ? prev : current;
            }).weight
        );
      } else {
        totalSubWeight += parseFloat(
          x.salesOfficeOutWardStock.graderStock.stockGraderInWards.reduce(
            (accum, curr) => {
              if (typeof accum == "object") {
                accum = parseFloat(accum.weight);
                accum +=  parseFloat(curr.weight);
              } else {
                accum += parseFloat(curr.weight);
              }
              return accum;
            }
          )
        );
      }
    });

    let totalSubPieces = 0;

    this.state.ledgerDetailStock.map(x => {
      if (
        x.mainJangad.jangads.reduce((prev, current) => {
          return prev.cycle < current.cycle ? prev : current;
        }).factory.isInternal != true
      ) {
        totalSubPieces += parseInt(
          x.mainJangad.jangads
            .filter(x => x.factoryId == this.state.props.data.factoryId)
            .reduce((prev, current) => {
              return prev.cycle < current.cycle ? prev : current;
            }).pieces
        );
      } else {
        totalSubPieces += parseInt(
          x.salesOfficeOutWardStock.graderStock.stockGraderInWards.length
        );
      }
    });

    let totalSubAmount = 0;
    totalSubAmount += parseFloat(
      this.state.ledgerDetailStock.map(x => {
        if (
          x.mainJangad.jangads.reduce((prev, current) => {
            return prev.cycle < current.cycle ? prev : current;
          }).factory.isInternal != true
        ) {
          return (
            x.mainJangad.pRate *
            x.mainJangad.jangads
              .filter(x => x.factoryId == this.state.props.data.factoryId)
              .reduce((prev, current) => {
                return prev.cycle < current.cycle ? prev : current;
              }).weight
          );
        } else {
          return (
            x.mainJangad.pRate *
            parseFloat(
              x.salesOfficeOutWardStock.graderStock.stockGraderInWards.reduce(
                (accum, curr) => {
                  if (typeof accum == "object") {
                    accum = parseFloat(accum.weight);
                    accum +=  parseFloat(curr.weight);
                  } else {
                    accum += parseFloat(curr.weight);
                  }
                  return accum;
                }
              )
            )
          );
        }
      })
    );
    this.setState({
      totalWeight: totalSubWeight,
      totalPieces: totalSubPieces,
      totalAmount: totalSubAmount,
    });
  }
  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  printIframe = async (e, id) => {
    e.preventDefault();
    const iframe = (await document.frames)
      ? document.frames[id]
      : document.getElementById(id);
    const iframeWindow = iframe.contentWindow || iframe;

    iframe.focus();
    iframeWindow.print();

    return false;
  };

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  async update() {
    if (this.state.props.data.printDate == null) {
      const data = await updateLedgers({
        id: this.state.props.data.id,
        printStatus: "Yes",
        printDate: moment().format("YYYY-MM-DD"),
      });
    }
  }

  render() {
    this.columns2 = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        footer: "05",
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        footer: "7.50 CT",
      },

      {
        dataField: "rate",
        text: `${this.props.t("Rate")}`,
        footer: "",
      },
      {
        dataField: "amount",
        text: `${this.props.t("Amount")}`,
        footer: "750",
      },
    ];

    document.title = `Ledger ${moment().format("DD-MM-YYYY")}`;

    let weight = 0;
    let pieces = 0;
    this.state.props.data.ledgerDetails.map((start, next) => {
      let data = start.mainJangad.jangads.filter(x => x.cycle == 1);
      if (data.length > 0)
        return (pieces += start.mainJangad.jangads.filter(x => x.cycle == 1)[0]
          .pieces);
      else return pieces;
    });
    this.state.props.data.ledgerDetails.map((start, next) => {
      let data = start.mainJangad.jangads.filter(x => x.cycle == 1);
      if (data.length > 0)
        return (weight += start.mainJangad.jangads.filter(x => x.cycle == 1)[0]
          .weight);
      else return weight;
    });
    return (
      <React.Fragment>
        {[1, 2].map(x => {
          return (
            <>
              <div
                className={`ledgerDetailView border border-2 border-dark mx-1 width-height`}
              >
                {this.state.ledgerDetailStock &&
                Object.keys(this.state.organizations).length > 0 ? (
                  <>
                    <Card className="pb-5 mb-0">
                      <div>
                        <h2 className="fw-bold pt-2 text-center text-black">
                          P3Y Diamond Tech
                        </h2>
                        <div className="border_dark"></div>
                        <h5 className="text-center pt-1">
                          {this.state.organizations.addressLine1}{" "}
                          {this.state.organizations.addressLine2}
                        </h5>

                        <div className="d-flex px-1 justify-content-between">
                          <div>
                            <h5 className="text-black d-inline fw-bold">
                              {" "}
                              Email:
                            </h5>
                            <p className="d-inline fs-5 ps-2">
                              {this.state.organizations.email}
                            </p>
                          </div>
                          <div>
                            <h5 className="text-black d-inline fw-bold">
                              GSTIN/UIN:
                            </h5>
                            <p className="d-inline fs-5 ps-2">
                              {this.state.organizations.gstNo}
                            </p>
                          </div>
                        </div>

                        <div className="border_dark"></div>
                        <h4 className="fw-bold text-center py-1 text-black">
                          Ledger
                        </h4>
                        <div className="border_dark"></div>

                        <div className="d-sm-flex d-block text-sm-start text-center justify-content-between px-1">
                          <div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                {this.props.t("Factory Name")}:
                              </h5>{" "}
                              <p className="d-inline fs-5 ps-2">
                                {this.state.props.data.factory.name}
                              </p>
                            </div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                Address:
                              </h5>{" "}
                              <p className="d-inline fs-5 ps-2">
                                {this.state.props.data.factory.addressLine1}
                              </p>
                            </div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                GSTIN/UIN:
                              </h5>{" "}
                              <p className="d-inline fs-5 ps-2">
                                {this.state.props.data.factory.gstNo}
                              </p>
                            </div>
                          </div>
                          <div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                Date:
                              </h5>{" "}
                              <p className="d-inline fs-5 ps-2">
                                {moment().format("DD-MM-YYYY")}
                              </p>
                            </div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                Time:
                              </h5>{" "}
                              <p className="d-inline fs-5 ps-2">
                                {moment().format("hh:mm:ss A")}
                              </p>
                            </div>
                            <div></div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                Ledger No:
                              </h5>
                              <p className="d-inline fs-5 ps-2">
                                {this.state.props.data.id}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="text-end pb-0 mb-0 fs-5 col-8">
                            <p className="pb-0 mb-0">
                              {"["}
                              {moment(this.state.props.data.fromDate).format(
                                "DD-MM-YYYY"
                              )}{" "}
                              <span className="fw-bold text-dark">To</span>{" "}
                              {moment(this.state.props.data.toDate).format(
                                "DD-MM-YYYY"
                              )}
                              {"]"}
                            </p>
                          </div>
                          <div className="text-center col-4 ps-2">
                            <p className="pb-0 mb-0 me-5 pe-5 fs-5 fw-bold text-dark">
                              {x == 1 ? "ORIGINAL" : ""}
                            </p>
                          </div>
                        </div>
                        <div className="pt-3 px-3">
                          <div className="table-responsive">
                            <table className="table table-bordered background-light1 text-center">
                              <thead className="fs-5 fw-bold">
                                <tr className="p-0">
                                  <th className="p-0">
                                    {this.props.t("Jangad ID")}
                                  </th>
                                  <th className="p-0">
                                    {this.props.t("Pieces")}
                                  </th>
                                  <th className="p-0">
                                    {this.props.t("Weight Crt")}
                                  </th>
                                  <th className="p-0">
                                    {this.props.t("Category")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="fs-5 foo1">
                                {this.state.ledgerDetailStock
                                  .sort(
                                    (a, b) =>
                                      a.mainJangad.createdAt -
                                      b.mainJangad.createdAt
                                  )
                                  .map(x => {
                                    return (
                                      <tr className="p-0" key={x.id}>
                                        <td className="p-0">
                                          {moment(
                                            x.mainJangad.createdAt
                                          ).format("DD-MM-YYYY")}
                                        </td>
                                        <td className="p-0">
                                          {x.mainJangad.jangads.reduce(
                                            (prev, current) => {
                                              return prev.cycle < current.cycle
                                                ? prev
                                                : current;
                                            }
                                          ).factory.isInternal != true
                                            ? x.mainJangad?.jangads
                                                ?.filter(
                                                  x =>
                                                    x.factoryId ==
                                                    this.state.props.data
                                                      .factoryId
                                                )
                                                .reduce((prev, current) => {
                                                  return prev.cycle <
                                                    current.cycle
                                                    ? prev
                                                    : current;
                                                }).pieces
                                            : x.salesOfficeOutWardStock
                                                .graderStock.stockGraderInWards
                                                .length}
                                        </td>
                                        <td className="p-0">
                                          {x.mainJangad.jangads.reduce(
                                            (prev, current) => {
                                              return prev.cycle < current.cycle
                                                ? prev
                                                : current;
                                            }
                                          ).factory.isInternal != true
                                            ? x.mainJangad?.jangads
                                                ?.filter(
                                                  x =>
                                                    x.factoryId ==
                                                    this.state.props.data
                                                      .factoryId
                                                )
                                                .reduce((prev, current) => {
                                                  return prev.cycle <
                                                    current.cycle
                                                    ? prev
                                                    : current;
                                                }).weight
                                            : x.salesOfficeOutWardStock.graderStock.stockGraderInWards.reduce(
                                                (accum, curr) => {
                                                  if (
                                                    typeof accum == "object"
                                                  ) {
                                                    accum = parseFloat(
                                                      accum.weight
                                                    );
                                                    accum +=  parseFloat(curr.weight);
                                                  } else {
                                                    accum += parseFloat(
                                                      curr.weight
                                                    );
                                                  }
                                                  return accum;
                                                }
                                              )}
                                        </td>
                                        <td className="p-0">
                                          {x.mainJangad.category.name}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                              <tfoot>
                                <tr className="fs-5 p-0 fw-bold">
                                  <th className="p-0">
                                    {this.props.t("Total")}
                                  </th>
                                  <th className="p-0">
                                    {this.state.totalPieces}
                                  </th>
                                  <th className="p-0">
                                    {this.state.totalWeight}
                                  </th>
                                  <th className="p-0"></th>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>

                        <div className="px-3">
                          <h4 className="fw-bold text-black pt-2">
                            Terms and Conditions
                          </h4>
                          {this.state.organizations.tac
                            .split("(")
                            .map((x, index) => {
                              if (x == "") {
                                return null;
                              } else {
                                return (
                                  <p
                                    key={index}
                                    className="fs-5 text-black pb-0 mb-0"
                                  >
                                    {" "}
                                    {x}{" "}
                                  </p>
                                );
                              }
                            })}
                          <h4 className="fw-bold text-black pt-2">
                            Declaration
                          </h4>
                          {this.state.organizations.declaration
                            .split("(")
                            .map((x, index) => {
                              if (x == "") {
                                return null;
                              } else {
                                return (
                                  <p
                                    key={index}
                                    className="fs-5 text-black pb-0 mb-0"
                                  >
                                    {" "}
                                    {x}{" "}
                                  </p>
                                );
                              }
                            })}
                          <div className="d-sm-flex d-block justify-content-between">
                            <div>
                              <h5>
                                For <strong> Receiver:</strong>
                              </h5>
                            </div>
                            <div>
                              <h5>
                                for
                                <strong> P3Y Diamond Tech</strong>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                    {/* {this.state.ledgerDetailStock.map(x => {
                return (
                  <iframe
                    id="receipt"
                    key={x.id}
                    style={{ display: "none" }}
                    title="Receipt"
                    allowFullScreen="true"
                    sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
                    srcDoc={`<div class="border"> <h2 class="text-center">
                  P3Y Diamond Tech
                </h2>
                <hr/>
                  <div class="text-center">
                    <p class=""> ${this.state.organizations.addressLine1}</p>
                    <p class="">${this.state.organizations.addressLine2}</p>
                  </div>
                  <div class="d-flex padding-10">
                  
                  <p class=""> Email: ${this.state.organizations.email}</p>
                      <p class="">
                        GSTIN/UIN:${this.state.organizations.gstNo}
                      </p>
                  
                    
                      </div>
                      <hr/>
                <h4 class="text-center">
                  Delivery Challan
                </h4>
                <hr/>
                  <div class="d-flex padding-10">
                  <div>
                     
                      <p className="fw-bold d-inline text-black pt-2">
                        ${this.props.t("Factory Name")}: ${
                      x.salesOfficeOutWardStock.jangad.factory.name
                    }
                      </p>
                      <p className="fw-bold d-inline text-black pt-2">
                        Address: ${
                          x.salesOfficeOutWardStock.jangad.factory.addressLine1
                        }
                      </p>
                      <p className="fw-bold d-inline text-black pt-2">
                        GSTIN/UIN: ${
                          x.salesOfficeOutWardStock.jangad.factory.gstNo
                        }
                      </p>
                    </div>
                    <div>
                      <p className="fw-bold d-inline text-black pt-2">
                        Date: ${moment(
                          x.salesOfficeOutWardStock.jangad.createdAt
                        ).format("DD-MM-YYYY")}
                      </p>
                      <p className="fw-bold d-inline text-black pt-2">
                        Time: ${moment(
                          x.salesOfficeOutWardStock.jangad.createdAt
                        ).format("hh:mm:ss A")}
                      </p>
                    <p className="fw-bold text-black pt-2">Challan No: ${
                      x.id
                    }</p>
                  </div>
                  </div>

                  
                
             <table class="padding-10" width="100%">
                     
                      <tr>
                        <th>Id:</th>
                        <th>Pieces:</th>
                        <th>Weight:</th>
                        <th>Category:</th>
                        
                      </tr>
                      ${this.state.ledgerDetailStock.map(x => {
                        return `<tr>
                      <td>${x.id}</td>
                        
                        <td>${
                          x.mainJangad.jangads.reduce((prev, current) => {
                            return prev.cycle < current.cycle ? prev : current;
                          }).factory.isInternal != true
                            ? x.mainJangad?.jangads
                                ?.filter(
                                  x =>
                                    x.factoryId ==
                                    this.state.props.data.factoryId
                                )
                                .reduce((prev, current) => {
                                  return prev.cycle < current.cycle
                                    ? prev
                                    : current;
                                }).pieces
                            : x.salesOfficeOutWardStock.graderStock
                                .stockGraderInWards.length
                        }</td>
                        <td>${
                          x.mainJangad.jangads.reduce((prev, current) => {
                            return prev.cycle < current.cycle ? prev : current;
                          }).factory.isInternal != true
                            ? x.mainJangad?.jangads
                                ?.filter(
                                  x =>
                                    x.factoryId ==
                                    this.state.props.data.factoryId
                                )
                                .reduce((prev, current) => {
                                  return prev.cycle < current.cycle
                                    ? prev
                                    : current;
                                }).weight
                            : x.salesOfficeOutWardStock.graderStock.stockGraderInWards.reduce(
                                (accum, curr) => {
                                  if (typeof accum == "object") {
                                    accum = parseInt(accum.weight);
                                  } else {
                                    accum += parseInt(curr.weight);
                                  }
                                  return accum;
                                }
                              )
                        }</td>
                        <td>${ x.salesOfficeOutWardStock.mainJangad.category.name}</td>
                      </tr>`;
                      })}
                     
                      <tfoot>
    <tr>
      <td>Total: </td>
      <td>${this.state.totalPieces}</td>
      <td>${this.state.totalWeight}</td>
      <td></td>
    </tr>
  </tfoot>
                    </table> 
                    <div>
                      <h4 class="padding-5">
                        Note: 
                      </h4>
                      </div>
                    <div class="d-flex">
                      <h4 class="border-bottom1 w-100 h-100 m-0 padding-50">
                        For Receiver: 
                        
                      </h4>
                      <h4 class="border-bottom2 w-100 h-100 m-0 padding-50">
                        For P3Y Diamond Tech 
                       
                      </h4>
                      </div>

                      </div>
                    <style>
                    
                    table, th, td{
                      border:1px solid gray;
                      border-collapse: collapse;
                      text-align: left;
                    }
                    .text-align-left{
                      text-align: left;
                    }
                    .w-100{
                      width: 100%;
                    }
                    .h-100{
                      height: 100%;
                    }
                    .m-0{
                      margin:0;
                    }
                    .border-bottom1{
border-top:1px solid gray;
border-right:1px solid gray;
                    }
                    .border-bottom2{
border-top:1px solid gray;
                    }
                    .d-flex{
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    }
                    .width-50{
                      width: 50%;
                    }
                    .border{
                      border: 1px solid black;
                    }
                    .text-center{
                     text-align: center;
                    }
                    .padding-0{
                      padding: 0px;
                    }
                    .padding-5{
                      padding: 0px 0px 30px 2px;
                    }
                    .padding-50{
                      padding:0px 2px 50px 2px;
                    }
                    .padding-10{
                      padding: 0px 5px;
                    }
                    @media print {
                      .no-print,
                      .no-print * {
                          display: none !important;
                      }

                    }
                    </style>
                    <button
                    class="no-print"
                      type="button"
                      onclick="window.print()"
                    >
                      Print
                    </button>`}
                  ></iframe>
                );
              })} */}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </>
          );
        })}
        <div className="ledgerPrintView page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("REPORTS")} />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={{}}
                validationSchema={Yup.object().shape({
                  attachment: Yup.mixed()
                    .nullable()
                    .notRequired()
                    .test(
                      "FILE_SIZE",
                      "Uploaded file is too big.",
                      value => !value || (value && value.size <= FILE_SIZE)
                    )
                    .test(
                      "FILE_FORMAT",
                      "Uploaded file has unsupported format.",
                      value =>
                        !value ||
                        (value && SUPPORTED_FORMATS.includes(value.type))
                    ),
                })}
                onSubmit={values => {}}
              >
                {({ errors, status, touched, values }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                              {this.props.t("View Ledger report")}
                            </h4>
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>
                        <div className="col-xl-8 col-12">
                          <CardBody>
                            <Row>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="ledgerID"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Ledger Id")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.ledgerID && touched.ledgerID
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={this.state.props.data.id}
                                    readOnly={true}
                                    type="text"
                                    name="ledgerID"
                                    placeholder="JANGAD0000123"
                                  />
                                  <ErrorMessage
                                    name="ledgerID"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="factoryName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Factory Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.factoryName && touched.factoryName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={this.state.props.data.factory.name}
                                    readOnly={true}
                                    type="text"
                                    name="factoryName"
                                    placeholder="XYZ Diamond"
                                  />
                                  <ErrorMessage
                                    name="factoryName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="totalPcs"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total No of Pieces")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.totalPcs && touched.totalPcs
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={pieces}
                                    readOnly={true}
                                    type="number"
                                    onWheel={e => e.target.blur()}
                                    name="totalPcs"
                                    placeholder="30"
                                  />
                                  <ErrorMessage
                                    name="totalPcs"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="weight"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total Weight")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.weight && touched.weight
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={weight}
                                    readOnly={true}
                                    type="number"
                                    onWheel={e => e.target.blur()}
                                    name="weight"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="weight"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </Row>
                          </CardBody>
                        </div>
                        <div className="col-xl-4 col-12 pt-3">
                          <div className="px-4">
                            <div className="row border-gray py-3">
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Contact Person")} :</h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>{this.state.props.data.factory.name}</h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Mobile no.1")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>
                                  {this.state.props.data.factory.mobileNo1}
                                </h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Mobile no.2")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>
                                  {this.state.props.data.factory.mobileNo2}
                                </h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Email Address")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>{this.state.props.data.factory.email}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {this.state.ledgerDetailStock.map(x => {
                        return (
                          <div key={x.id + "1"} className="row px-4 pt-3">
                            <table className="background-light fs-5 foo">
                              <tr className="py-2">
                                <th className="px-2 py-2">
                                  {this.props.t("Jangad Id")}
                                </th>
                                <th className="px-2 py-2">
                                  {this.props.t("From Date")}
                                </th>
                                <th className="px-2 py-2">
                                  {this.props.t("To Date")}
                                </th>
                                <th className="px-2 py-2">
                                  {this.props.t("Category Name")}
                                </th>
                              </tr>
                              <tr>
                                <td className="px-2 py-2">
                                  {x.mainJangad.name}
                                </td>
                                <td className="px-2 py-2">
                                  {" "}
                                  {this.props.t("From Date")} :{" "}
                                  {moment(
                                    x.salesOfficeOutWardStock.createdAt
                                  ).format("DD/MM/YYYY")}
                                </td>
                                <td className="px-2 py-2">
                                  {" "}
                                  {this.props.t("To Date")} :{" "}
                                  {moment(
                                    x.salesOfficeOutWardStock.updatedAt
                                  ).format("DD/MM/YYYY")}
                                </td>
                                <td className="px-2 py-2">
                                  {x.mainJangad.category.name}
                                </td>
                              </tr>
                            </table>
                          </div>
                        );
                      })}
                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="notes"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t("Ledger Notes")}
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.notes && touched.notes
                                ? " is-invalid"
                                : "")
                            }
                            readOnly={true}
                            value={this.state.props.data.notes}
                            type="text"
                            name="notes"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="notes"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="col-md-12 text-center text-md-end pe-3 py-5">
                        <div className="btn-group">
                          <Button
                            type="button"
                            className="py-2 px-2 border-0 bg-success rounded me-3"
                            onClick={() => window.print()}
                          >
                            <img
                              src="images/dashboard-images/printwhite.svg"
                              className="text-white"
                              alt="print"
                            />
                          </Button>
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={() => this.update()}
                          >
                            Print
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(ExternalPrintLedgerReport);
